export default "__VITE_ASSET__a0ddf0b6__"